(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-carousel')) {
    class BeforeAfterCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.progress = this.querySelector('[data-progress]');
        this.progressTrack = this.progress ? this.progress.parentElement : null;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        if (this.progressTrack) {
          this.progressTrack.addEventListener('pointerdown', this.onPointerDown.bind(this));
          this.progressTrack.addEventListener('pointermove', this.onPointerMove.bind(this));
          this.progressTrack.addEventListener('pointerup', this.onPointerUp.bind(this));
          this.progressTrack.addEventListener('pointercancel', this.onPointerUp.bind(this));
        }
        this.update();
      }

      // Drag the thumb, or press anywhere on the track to jump there (thumb centred on the pointer)
      onPointerDown(event) {
        if (event.button !== 0) return;
        const thumb = this.progress.getBoundingClientRect();
        this.dragOffset = event.target === this.progress ? event.clientX - thumb.left : thumb.width / 2;
        this.dragging = true;
        this.progressTrack.setPointerCapture(event.pointerId);
        this.progressTrack.classList.add('is-dragging');
        // Instant, unsnapped scrolling while dragging so the thumb follows the pointer
        this.track.style.scrollBehavior = 'auto';
        this.track.style.scrollSnapType = 'none';
        this.scrollToPointer(event);
      }

      onPointerMove(event) {
        if (this.dragging) this.scrollToPointer(event);
      }

      onPointerUp(event) {
        if (!this.dragging) return;
        this.dragging = false;
        this.progressTrack.classList.remove('is-dragging');
        if (this.progressTrack.hasPointerCapture(event.pointerId)) {
          this.progressTrack.releasePointerCapture(event.pointerId);
        }
        // Restore snapping; the browser settles on the nearest card
        this.track.style.scrollBehavior = '';
        this.track.style.scrollSnapType = '';
      }

      scrollToPointer(event) {
        const rect = this.progressTrack.getBoundingClientRect();
        const thumbWidth = this.progress.offsetWidth;
        const range = rect.width - thumbWidth;
        const ratio = range > 0 ? (event.clientX - rect.left - this.dragOffset) / range : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollLeft = Math.min(Math.max(ratio, 0), 1) * maxScroll;
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      go(direction) {
        const item = this.track.firstElementChild;
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;
        const visibleRatio = scrollWidth ? clientWidth / scrollWidth : 1;

        if (this.progress) {
          const barWidth = Math.max(visibleRatio, 0.1) * 100;
          const ratio = maxScroll > 0 ? scrollLeft / maxScroll : 0;
          this.progress.style.width = barWidth + '%';
          this.progress.style.transform = 'translateX(' + ratio * ((100 - barWidth) / barWidth) * 100 + '%)';
        }
        if (this.progressTrack) this.progressTrack.hidden = maxScroll <= 1;
        if (this.prev) this.prev.disabled = scrollLeft <= 1;
        if (this.next) this.next.disabled = scrollLeft >= maxScroll - 1;
      }
    }

    customElements.define('before-after-carousel', BeforeAfterCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
